<template>
  <v-layout row wrap justify-center align-center class="pb-8">
    <v-flex xs12 class="mt-3 mb-2 text-center">
      <v-row class="no-gutters pt-2 text-center">
        <v-col cols="12" class="cont-titulo-white text-center mb-2">
          <h1> {{itemsec.titulo}} </h1>
        </v-col>
      </v-row>
    <v-divider></v-divider>
    </v-flex>
    <v-flex xs12 sm8 v-if="cargando">
      <v-skeleton-loader
        class="mx-auto"
        max-width="500"
        type="card-avatar, article"
      ></v-skeleton-loader>
    </v-flex>
    <v-flex xs12 sm8 class="pa-5" v-else>
      <v-row class="no-gutters">
        <v-col cols="12" sm="4" class="text-center mx-auto pa-2">
          <v-img
          class="white--text align-end"
          aspect-ratio="1"
          cover
          :width="$vuetify.breakpoint.xs ? '100%' : '200px'" :src="oNoticia[0].imagen"
          >
          </v-img>
          <h4 class="text-left"> {{oNoticia[0].fecha}}</h4>
        </v-col>
        <v-col cols="12" sm="8" class="text-left mx-auto">
           <h2 class="lh-1-2 mb-2">{{oNoticia[0].titulo}}</h2>
           <p v-html="textoFiltrado"></p>
        </v-col>
      </v-row>
    </v-flex>
    <v-flex xs12 px-10>
      <v-divider></v-divider>
      <div>
        <h1 class="txt-primary"> Más Noticias </h1>
      </div>
    </v-flex>
    <v-flex xs12 class="no-gutters px-10" v-if="info.length >= 1">
      <v-sheet class="mx-auto" elevation="0" max-width="100%" color="transparent">
        <VueSlickCarousel v-bind="settings" class="text-center">
        <v-card class="ma-2" max-width="250" color="white" elevation="5" v-for="(noti, idx) in info"
          :key="'noti-'+idx">
              <v-img class="white--text align-end" height="200px"
              :src="noti.imagen"
              >
              </v-img>
            <v-card-subtitle class="pb-0">
              {{noti.fecha}}
            </v-card-subtitle>
            <v-card-text class="text--primary">
              <div class="lh-1-2 ">{{noti.titulo}}</div>
            </v-card-text>
            <v-card-actions class="d-flex justify-end">
              <v-btn color="primary" small text outlined rounded class="font-weight-bold"
              @click="leerMas(noti.id_noticia, noti.titulo)"
              >
                LEER MÁS
              </v-btn>
            </v-card-actions>
          </v-card>
          <template #prevArrow>
          <v-btn color="primary"
            fab
            dark
            small>
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          </template>
          <template #nextArrow>
              <v-btn color="primary"
              fab
              dark
              small>
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </template>
        </VueSlickCarousel>
      </v-sheet>
    </v-flex>
  </v-layout>

</template>

<script>
import axios from 'axios'
import navUser from '../components/nav-user'
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
export default {
  components: {
    navUser,
    VueSlickCarousel
  },
  metaInfo: {
    // title will be injected into parent titleTemplate
    titleTemplate: '%s| Noticias',
    meta: [
      { name: 'noticias', content: 'noticias' }
    ]
  },
  data () {
    return {
      itemsec: {
        titulo: 'Noticias y Novedades'
      },
      info: [],
      oNoticia: [],
      noticiaId: null,
      cargando: false,
      settings: {
        'dots': false,
        'infinite': true,
        'initialSlide': 0,
        'speed': 500,
        'slidesToShow': 4,
        'slidesToScroll': 1,
        'swipeToSlide': true,
        'arrows': true,
        'responsive': [
          {
            'breakpoint': 1024,
            'settings': {
              'slidesToShow': 3,
              'slidesToScroll': 3,
              'infinite': true
            }
          },
          {
            'breakpoint': 600,
            'settings': {
              'slidesToShow': 2,
              'slidesToScroll': 2
            }
          },
          {
            'breakpoint': 480,
            'settings': {
              'slidesToShow': 1,
              'slidesToScroll': 1
            }
          }
        ]
      }
    }
  },
  async created () {
    this.noticiaId = this.$store.state.idContenido
    this.getIdContenidoApp()
    await axios
      .get('' + this.$store.state.rutaApi + 'noticia')
      .then(response => (this.info = response.data))
  },
  mounted () {
    this.cargando = true
    this.noticiaId = this.$store.state.idContenido
    this.comprobar()
  },
  methods: {
    comprobar () {
      if (this.noticiaId == 0) {
        let routeArr = this.$route.path.split('/')
        let modId = routeArr[routeArr.length - 2]
        this.noticiaId = modId
        this.$store.dispatch('saveIdContenido', modId)
        this.getIdContenidoApp()
      } else {
        this.getIdContenidoApp()
      }
    },
    leerMas (val, name) {
      this.$store.dispatch('saveIdContenido', val)
      this.$router.replace({ name: 'noticias', params: { idCont: val, catName: name } }).catch(() => {})
      this.noticiaId = val
      this.comprobar()
    },
    async getIdContenidoApp () {
      this.cargando = true
      await axios
        .get('' + this.$store.state.rutaApi + 'noticia')
        .then(response => (this.info = response.data))
      this.actualCont()
      this.cargando = false
    },
    actualCont () {
      this.oNoticia = this.info.filter(item => item.id_noticia == this.noticiaId)
      // console.log('this.oNoticia ',this.oNoticia)
      this.textoFiltrado = this.oNoticia[0].texto.replace(/\r\n/g, '<br/>')
    }
  }
}
</script>
<style lang="scss" scoped>
.contenedor{
    height: auto;
}
.bdred{
  border: solid red;
}
h2{
  font-size: 1em;
}
</style>
